"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("../../../utils/styled-components");

exports.StyledSpinner = styled_components_1.default('svg')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // color: ", ";\n  :first-child {\n    stroke: ", ";\n  }\n"], ["\n  // color: ", ";\n  :first-child {\n    stroke: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primaryColor;
}, function (_a) {
  var theme = _a.theme,
      invertColor = _a.invertColor;
  return invertColor ? theme.colors.primaryLightColor : theme.colors.primaryDarkColor;
});
var templateObject_1;